export const sort = {
  sort: {
    shape:
      '<path fill="#000" fill-opacity=".98" d="M3.5 18.274v-1h5v1h-5Zm0-5.375v-1h11v1h-11Zm0-5.4v-1h17v1h-17Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
